import React from 'react';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  size?: IconSize;
}

const Location = (props: IconProps): JSX.Element => (
  <SvgIcon size={props.size}>
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9427 2C14.0485 2.00041 16.068 2.83726 17.5569 4.32647C19.0446 5.8161 19.8807 7.83583 19.8807 9.94113C19.8807 12.0467 19.0449 14.0661 17.5569 15.5558L11.9411 21.1716L6.32454 15.555C4.83575 14.0655 3.99959 12.0456 4 9.93958C4.00041 7.83346 4.83745 5.81377 6.32699 4.32481C7.81653 2.83585 9.83655 1.99959 11.9427 2ZM4.91032 16.9692L11.9411 24L18.9719 16.9692C20.8345 15.1045 21.8807 12.5767 21.8807 9.94113C21.8807 7.30554 20.8345 4.77775 18.9719 2.91306C17.108 1.04837 14.5796 0.000513213 11.9431 0C9.30651 -0.000512084 6.77774 1.04636 4.91306 2.91032C3.04837 4.77428 2.00051 7.30264 2 9.93919C1.99949 12.5757 3.04636 15.1045 4.91032 16.9692ZM10.8889 8.33706C11.2178 8.1173 11.6044 8 12 8C12.5304 8 13.0391 8.21071 13.4142 8.58579C13.7893 8.96086 14 9.46957 14 10C14 10.3956 13.8827 10.7822 13.6629 11.1111C13.4432 11.44 13.1308 11.6964 12.7654 11.8478C12.3999 11.9991 11.9978 12.0387 11.6098 11.9616C11.2219 11.8844 10.8655 11.6939 10.5858 11.4142C10.3061 11.1345 10.1156 10.7781 10.0384 10.3902C9.96126 10.0022 10.0009 9.60009 10.1522 9.23463C10.3036 8.86918 10.56 8.55682 10.8889 8.33706Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default Location;
